const APIUrl = window.location.origin;
const BasePathUrl = "/lk/auth";
const AUTH_COOKIE = "idsrv.session";

export {BasePathUrl, APIUrl, AUTH_COOKIE};
